module.exports = __webpack_public_path__ + "img/IMG_1156_L_WoodMatted_MockedUp.15113302.jpg";